export const MAINTENANCE_MODE = 'PAAR-2945-payex_maintenance_mode';
export const ENABLE_FEATURE = 'ENABLE_FEATURE';
export const FETCH_FEATURES_REQUEST = 'FETCH_FEATURES_REQUEST';
export const FETCH_FEATURES_SUCCESS = 'FETCH_FEATURES_SUCCESS';
export const FETCH_FEATURES_ERROR = 'FETCH_FEATURES_ERROR';
export const FF_HOLIDAY_BANNER_CN = 'PAAR-5353-holidayBannerCN';
export const FF_HOLIDAY_BANNER_IN = 'PAAR-7290-holidayBannerIN';
export const FF_HOLIDAY_BANNER_KR = 'PAAR-6781-holidayBannerKR';
export const FF_HOLIDAY_BANNER_VN = 'PAAR-7052-holidayBannerVN';
export const FF_HOLIDAY_BANNER_NP = 'PAAR-6809-holidayBannerNP';
export const FF_CAPTCHA = 'PAAR-4218-VerifyTokenInBackend';
export const FF_PAYING_FROM_INDIA_IN_USD = 'PAAR-5643-Mario';
export const FF_HIDE_SMS = 'LOOP-2203-hide-sms';
export const FF_ACCOUNT_MISMATCH = 'LOOP-2228-account-mismatch';
export const FF_CARD_ELEMENT_FLOW = 'PAAR-6964-CardElementFlow';
export const FF_OTP_VERIFICATION = 'PAAR-7073-otpVerification';
export const FF_OTP_SIGNUP_VERIFICATION = 'PAAR-7034-otpSignupVerification';
export const FF_OTP_PROFILE_VERIFICATION = 'PAAR-7206-otpProfileVerification';
export const FF_INDIA_TCS_NAVIGATION_FLOW = 'PAAR-7080-newIndiaTCSFlow';
export const FF_INDIA_FX_AB_TEST = 'PAAR-7300-hideNonFxIndia';
export const FF_CALCULATE_FOR_RBI = 'PAAR-7275-calculateForRbi';

export const FEATURES = [
  MAINTENANCE_MODE,
  FF_CAPTCHA,
  FF_HOLIDAY_BANNER_CN,
  FF_HOLIDAY_BANNER_IN,
  FF_HOLIDAY_BANNER_KR,
  FF_HOLIDAY_BANNER_VN,
  FF_HOLIDAY_BANNER_NP,
  FF_PAYING_FROM_INDIA_IN_USD,
  FF_HIDE_SMS,
  FF_ACCOUNT_MISMATCH,
  FF_CALCULATE_FOR_RBI,
] as const;

export const FEATURE_TYPES = [FF_CAPTCHA, MAINTENANCE_MODE] as const;

export type FeatureFlag =
  | (typeof FEATURES)[number]
  | (typeof FEATURE_TYPES)[number];
